var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvisos = function SvgAvisos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avisos_svg__Capa_1",
    clipPath: "url(#avisos_svg__clip0_295_79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "avisos_svg__Vector",
    fill: "#19D3C5",
    d: "M23.996 47.991c13.252 0 23.995-10.743 23.995-23.995S37.248 0 23.996 0 0 10.743 0 23.996 10.743 47.99 23.996 47.99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "avisos_svg__Group",
    fill: "#510C76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "avisos_svg__Vector_2",
    d: "M23.996 40.572a4.254 4.254 0 1 0 0-8.509 4.254 4.254 0 0 0 0 8.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "avisos_svg__Vector_3",
    d: "M23.996 28.613a3.607 3.607 0 0 0 3.597-3.39l.856-14.44a3.603 3.603 0 0 0-3.597-3.813h-1.704a3.603 3.603 0 0 0-3.597 3.813l.856 14.44a3.6 3.6 0 0 0 3.598 3.39z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avisos_svg__clip0_295_79"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgAvisos;